
import Component from '../../../assets/scripts/modules/component'

export default class MenuOverlayComponent extends Component {
  init () {
    this.overlay = document.querySelector('.menu-overlay')

    if (!this.overlay) {
      return
    }

    this.wrapper = this.element.querySelector('.menu-overlay__wrapper')
    this.buttonLogin = this.overlay.querySelector('.button--login')

    this.buttonLogin?.addEventListener('click', () => localStorage.setItem('login', true))
    this.focusableElements = [...this.overlay.querySelectorAll('a[href], button, input, select')]
    this.focusableElements.forEach(element => element.setAttribute('tabindex', -1))

    window.addEventListener('open-menu-overlay', () => this.toggleOverlay())
    window.addEventListener('close-menu-overlay', () => this.toggleOverlay(true))
  }

  toggleOverlay (forceClose = false) {
    const closing = forceClose || document.documentElement.classList.contains('overlay-visible')

    if (document.documentElement.classList.contains('overlay-closing') || document.documentElement.classList.contains('overlay-opening')) {
      return
    }

    document.documentElement.classList.toggle('overlay-visible', !closing)
    document.documentElement.classList.toggle('prevent-scrolling', !closing)

    if (closing) {
      document.documentElement.classList.add('overlay-closing')
      this.focusableElements.forEach(element => element.setAttribute('tabindex', -1))

      window.setTimeout(() => {
        document.documentElement.classList.remove('overlay-closing')

        if (this.wrapper) {
          this.wrapper.scrollTo(0, 0)
        }
      }, 350)

      const button = document.querySelector('.menu-bar .button--menu')

      if (button) {
        button.focus()
        window.requestAnimationFrame(() => button.blur())
      }
    } else {
      document.documentElement.classList.add('overlay-opening')
      this.focusableElements.forEach(element => element.removeAttribute('tabindex'))

      window.setTimeout(() => {
        document.documentElement.classList.remove('overlay-opening')
      })

      const firstLink = this.overlay.querySelector('a')

      if (firstLink) {
        firstLink.focus()
        window.requestAnimationFrame(() => firstLink.blur())
      }
    }
  }
}

window.addEventListener('init-load', () => document.querySelectorAll('.menu-overlay').forEach(element => {
  element.instance = element.instance || new MenuOverlayComponent(element)
}))
